import { CardImages } from "../../models/cards/cardImages";

export class EmptyImage implements CardImages {
    id: Number = null;
    image_url: string = ''
    image_url_small: string = '';
}